import React from 'react';
import { forceCheck } from 'react-lazyload';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import BeerHover from 'images/beer-hover.jpg';
import MixersHover from 'images/mixers-hover.jpg';
import SpiritsHover from 'images/spirits-hover.jpg';
import WineHover from 'images/wine-hover.jpg';

export default function HeaderNav() {
  return (
    <div id="nav-left">
      <div
        className="category nav-link-dropdown"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/beer">
          <span className="nav-link-label">Beer</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={BeerHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">Trending Beer</div> */}
            <Link to="/beer?varietal=light%20lager">
              <span className="nav-link-dropdown-label">Lager</span>
            </Link>
            <Link to="/beer?varietal=india%20pale%20ale">
              <span className="nav-link-dropdown-label">IPA</span>
            </Link>
            <Link to="/beer?varietal=belgian%20and%20french%20ale&varietal=belgian%20strong%20ale">
              <span className="nav-link-dropdown-label">Belgian Ale</span>
            </Link>
            <Link to="/beer?varietal=standard%20cider%20and%20perry">
              <span className="nav-link-dropdown-label">Cider</span>
            </Link>
            <Link to="/beer?varietal=american%20ale&varietal=english%20ale">
              <span className="nav-link-dropdown-label">Pale Ale</span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/beer?varietal=pilsner">
              <span className="nav-link-dropdown-label">Pilsner</span>
            </Link>
            <Link to="/beer?varietal=light%20lager&varietal=american%20ale">
              <span className="nav-link-dropdown-label">Light</span>
            </Link>
            <Link to="/beer?varietal=belgian%20and%20french%20ale">
              <span className="nav-link-dropdown-label">Wheat</span>
            </Link>
            <Link to="/beer?varietal=porter&varietal=stout">
              <span className="nav-link-dropdown-label">
                Porter &amp; Stout
              </span>
            </Link>
            <Link to="/beer?varietal=sour%20ale">
              <span className="nav-link-dropdown-label">Sour Ale</span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/beer?varietal=american%20ale">
              <span className="nav-link-dropdown-label">American Ale</span>
            </Link>
            <Link to="/beer?varietal=german%20wheat%20and%20rye">
              <span className="nav-link-dropdown-label">
                German Wheat &amp; Rye
              </span>
            </Link>
            <Link to="/beer">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div
        className="category nav-link-dropdown"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/wine">
          <span className="nav-link-label">Wine</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={WineHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            <Link to="/red-wine">
              <div className="nav-link-dropdown-label dropdown-category-title">
                Red Wine
              </div>
            </Link>
            <Link to="/red-wine?varietal=cabernet%20sauvignon">
              <span className="nav-link-dropdown-label">
                Cabernet Sauvignon
              </span>
            </Link>
            <Link to="/red-wine?varietal=merlot">
              <span className="nav-link-dropdown-label">Merlot</span>
            </Link>
            <Link to="/red-wine?varietal=pinot%20noir">
              <span className="nav-link-dropdown-label">Pinot Noir</span>
            </Link>
            <Link to="/red-wine?varietal=malbec">
              <span className="nav-link-dropdown-label">Malbec</span>
            </Link>
            <Link to="/red-wine">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/white-wine">
              <span className="nav-link-dropdown-label dropdown-category-title">
                White Wine
              </span>
            </Link>
            <Link to="/white-wine?varietal=sauvignon%20blanc">
              <span className="nav-link-dropdown-label">Sauvignon Blanc</span>
            </Link>
            <Link to="/white-wine?varietal=chardonnay">
              <span className="nav-link-dropdown-label">Chardonnay</span>
            </Link>
            <Link to="/white-wine?varietal=pinot%20grigio%2Fpinot%20gris">
              <span className="nav-link-dropdown-label">Pinot Grigio</span>
            </Link>
            <Link to="/white-wine?varietal=riesling">
              <span className="nav-link-dropdown-label">Riesling</span>
            </Link>
            <Link to="/white-wine">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/wine">
              <span className="nav-link-dropdown-label dropdown-category-title">
                More Wines
              </span>
            </Link>
            <Link to="/rose">
              <span className="nav-link-dropdown-label">Rosé</span>
            </Link>
            <Link to="/champagne-sparkling">
              <span className="nav-link-dropdown-label">
                Champagne &amp; Sparkling
              </span>
            </Link>
            <Link to="/dollar-wines">
              <span className="nav-link-dropdown-label">Dollar Wines</span>
            </Link>
            <Link to="/wine">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div
        className="category nav-link-dropdown"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/spirits">
          <span className="nav-link-label">Spirits</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={SpiritsHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">Trending Spirits</div> */}
            <Link to="/whiskey">
              <span className="nav-link-dropdown-label">Whiskey</span>
            </Link>
            <Link to="/vodka">
              <span className="nav-link-dropdown-label">Vodka</span>
            </Link>
            <Link to="/rum">
              <span className="nav-link-dropdown-label">Rum</span>
            </Link>
            <Link to="/tequila">
              <span className="nav-link-dropdown-label">
                Tequila &amp; Mezcal
              </span>
            </Link>
            <Link to="/tequila?style=reposado">
              <span className="nav-link-dropdown-label">Reposado</span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/gin">
              <span className="nav-link-dropdown-label">Gin</span>
            </Link>
            <Link to="/cordials">
              <span className="nav-link-dropdown-label">Cordials</span>
            </Link>
            <Link to="/cocktails-combos">
              <span className="nav-link-dropdown-label">
                Cocktails & Combos
              </span>
            </Link>
            <Link to="/whiskey?style=bourbon">
              <span className="nav-link-dropdown-label">Bourbon</span>
            </Link>
            <Link to="/whiskey?style=irish%20whiskey">
              <span className="nav-link-dropdown-label">Irish Whiskey</span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/rum?style=flavored">
              <span className="nav-link-dropdown-label">Flavored</span>
            </Link>
            <Link to="/rum?style=aged%20rum">
              <span className="nav-link-dropdown-label">Aged Rum</span>
            </Link>
            <Link to="/spirits">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="category nav-link-dropdown category--gifting">
        <a href="/gifting">
          <span className="nav-link-label">Gifts</span>
        </a>
      </div>

      <div
        className="category nav-link-dropdown visible-lg-inline"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/more">
          <span className="nav-link-label">More</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={MixersHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            <Link to="/mixers">
              <div className="nav-link-dropdown-label dropdown-category-title">
                Mixers
              </div>
            </Link>
            <Link to="/mixers?style=apple&style=cherries%2Fberries&style=cranberry&style=grape&style=orange&style=orange%20juice&style=pineapple&style=pomegranate&style=puree">
              <span className="nav-link-dropdown-label">Juices</span>
            </Link>
            <Link to="/mixers?style=7up&style=coke&style=cream%20soda&style=flavored&style=root%20beer&style=tonic%2Fclub%20soda&style=sparkling">
              <span className="nav-link-dropdown-label">Soda</span>
            </Link>
            <Link to="/mixers?style=still">
              <span className="nav-link-dropdown-label">Water</span>
            </Link>
            <Link to="/mixers?style=bitters&style=syrup">
              <span className="nav-link-dropdown-label">
                Bitters &amp; Syrups
              </span>
            </Link>
            <Link to="/mixers">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/snacks">
              <div className="nav-link-dropdown-label dropdown-category-title">
                Snacks
              </div>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/cigars-tobacco">
              <span className="nav-link-dropdown-label dropdown-category-title">
                Cigars &amp; Tobacco
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="category visible-lg-inline">
        <a href="/bartenders">
          <span className="nav-link-label">Book a Bartender</span>
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/components/header/nav.js